export default [
    {
        value: "ApoioRealizacaoCitenel",
        text: "Apoio à realização do CITENEL"
    },
    {
        value: "Outros",
        text: "Outros"
    }
]